import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, Ref } from "vue";
import { encryptionMatchLineUp, encryptionPlayerStats } from "@/api/php/player";
import bg from "@/assets/images/img_football_formation.png";
import qiuyuan1 from "@/assets/images/ic_football_formation_cloth_home.png";
import qiuyuan2 from "@/assets/images/ic_football_formation_cloth_away.png";

import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
interface dataProps {
  type: any;
  id: string;
  roomdata: any;
}

const __default__ = {
  name: "TeamFootball",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: { type: null, required: true },
    id: { type: String, required: true },
    roomdata: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  type: any;
  id: string;
  roomdata: any;
}

const { t } = useI18n()
const route = useRoute();
let data = ref();
let team1 = ref("");
let team1logo = ref("");
let team2 = ref("");
let team2logo = ref("");
let hPlayers = ref();
let tbHomePlayers = ref();
let aPlayers = ref();
let tbAwayPlayers = ref();
let tbPlayer = ref();
let homePlayers = ref();
let awayPlayers = ref();
let footballtongji = [
  t('me.qy'),
  t('me.sf'),
  t('match.matchjq'),
  t('match.matchdq'),
  t('match.matchzg1'),
  t('match.matchtime'),
  t('match.matchhp'),
  t('match.matchhp2'),
  t('match.matchsm'),
  t('match.matchsz'),
  t('match.matchgr'),
  t('match.matchgrcg'),
  t('match.matchjw'),
  t('match.matcyxzd'),
  t('match.matclj'),
  t('match.matcqd'),
  t('match.matccq'),
  t('match.matccqcg'),
  t('match.matchczq'),
  t('match.matchczqcg'),
  t('match.matchcco'),
  t('match.matchccok'),
  t('match.matchpq'),
  t('match.matchpqcg'),
  t('match.matchdqe'),
  t('match.matchfg'),
  t('match.matchbqf'),
  t('match.matchpj'),
  t('match.matchqjq'),
  t('match.matchsmycj'),
  t('match.matchcjcg'),
  t('match.matchgkcj'),
  t('match.matchpf'),
];



onMounted(() => {
  if (props.type !== "" && props.id !== "") {
    getData();
  }
  teamname();
  getFootballPlayers();
});

const getData = async () => {
  const res: any = await encryptionMatchLineUp({
    type_id: props.type,
    id: props.id,
  });

  if (res.code == 200) {
    data.value = res.data;
    teadata(res.data);
  }
};
const getFootballPlayers = async () => {
  let { matchType, matchId } = route.query;

  if (
    matchId == "" ||
    matchId == null ||
    matchId == undefined ||
    matchId == "0"
  ) {
    if (props.roomdata.match_id) {
      matchId = props.roomdata.match_id;
    }

  }
  if (
    matchType == "" ||
    matchType == null ||
    matchType == undefined ||
    matchType == "0"
  ) {
    if (props.roomdata.type_id) {
      matchType = props.roomdata.type_id
    } else {
      matchType = props.roomdata.match_type;
    }
  }
  if (
    matchType != "" &&
    matchType != null &&
    matchType != undefined &&
    matchId != "" &&
    matchId != null &&
    matchId != undefined
  ) {
    let result: any = await encryptionPlayerStats({
      type_id: matchType,
      match_id: matchId,
    });


    if (result.code == 200) {
      let hometeamid = "";
      if (props.roomdata && props.roomdata.home_team_id) {
        hometeamid = props.roomdata.home_team_id;
      }
      if (result.data.player_stats && result.data.player_stats.length > 0) {
        let players = result.data.player_stats;
        let home = [];
        let away = [];
        if (hometeamid != "" && hometeamid != null && hometeamid != undefined) {
          for (let i = 0; i < players.length; i++) {
            if (players[i].team_id == hometeamid) {
              home.push(players[i]);
            } else {
              away.push(players[i]);
            }
          }
          // 球员统计数据
          homePlayers.value = home;
          awayPlayers.value = away;
        }
      }
    }
  }
};

const teamname = () => {
  // 队伍名称1
  if (
    props.roomdata &&
    props.roomdata.home_name != "" &&
    props.roomdata.home_name != null &&
    props.roomdata.home_name != undefined
  ) {
    team1.value = props.roomdata.home_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team1.value = arr[0];
  }
  team1logo.value = props.roomdata.home_logo;
  // 队伍名称2
  if (
    props.roomdata &&
    props.roomdata.away_name != "" &&
    props.roomdata.away_name != null &&
    props.roomdata.away_name != undefined
  ) {
    team2.value = props.roomdata.away_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team2.value = arr[1];
  }
  team2logo.value = props.roomdata.away_logo;
};

const teadata = (formations) => {
  // 首发阵容
  if (
    formations &&
    formations.home != "" &&
    formations.home != null &&
    formations.home != undefined
  ) {
    hPlayers.value = formations.home.filter((item) => {
      return item.first == 1;
    });
    // console.log("=====",hPlayers.value);
    // hPlayers.value.forEach(element => {
    //   console.log(element.shirt_number);
    // });

    tbHomePlayers.value = formations.home.filter((item) => {
      return item.first != 0;
    });
  }

  if (
    formations &&
    formations.away != "" &&
    formations.away != null &&
    formations.away != undefined
  ) {
    aPlayers.value = formations.away.filter((item) => {
      return item.first == 1;
    });
    tbAwayPlayers.value = formations.away.filter((item) => {
      return item.first != 0;
    });
  }
  if (tbHomePlayers.value && tbAwayPlayers.value) {
    tbPlayer.value =
      tbHomePlayers.value.length > tbAwayPlayers.value.length
        ? tbHomePlayers.value
        : tbAwayPlayers.value;
  }
};

const __returned__ = { t, route, data, team1, team1logo, team2, team2logo, hPlayers, tbHomePlayers, aPlayers, tbAwayPlayers, tbPlayer, homePlayers, awayPlayers, footballtongji, props, getData, getFootballPlayers, teamname, teadata, bg, qiuyuan1, qiuyuan2 }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})